<template>
  <div class="flow-panel">
    <div class="flow-title">水流分配情况</div>
    <div ref="chartRef" class="flow-chart"></div>
  </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from "vue";
import * as echarts from "echarts";

const chartRef = ref(null);
let chartInstance = null;

const initChart = () => {
  if (!chartRef.value) return;
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    title: {
      text: "2680吨",
      left: "center",
      top: "49%",
      textStyle: {
        color: "#fff",
        fontSize: 38,
        fontWeight: "bold",
        textShadowColor: "rgba(87, 255, 244, 0.42)",
        textShadowBlur: 8,
      },
    },
    tooltip: {
      trigger: "item",
      backgroundColor: "rgba(6, 54, 53, 0.96)",
      borderColor: "rgba(105, 255, 244, 0.55)",
      textStyle: { color: "#fff", fontSize: 22 },
      formatter: "{b}<br/>{c}吨",
    },
    series: [
      {
        type: "pie",
        radius: ["52%", "72%"],
        center: ["50%", "56%"],
        avoidLabelOverlap: false,
        label: { show: false },
        labelLine: { show: false },
        itemStyle: {
          borderColor: "#043b3b",
          borderWidth: 6,
        },
        data: [
          { name: "崇礼片区", value: 760, itemStyle: { color: "#d9ffc0" } },
          { name: "邵店片区", value: 690, itemStyle: { color: "#67ffe8" } },
          { name: "东洪片区", value: 640, itemStyle: { color: "#57dbe0" } },
          { name: "黄埠片区", value: 590, itemStyle: { color: "#7bfff0" } },
        ],
      },
      {
        type: "pie",
        radius: ["76%", "78%"],
        center: ["50%", "56%"],
        silent: true,
        label: { show: false },
        labelLine: { show: false },
        data: [
          { value: 86, itemStyle: { color: "rgba(110, 255, 244, 0.7)" } },
          { value: 14, itemStyle: { color: "transparent" } },
        ],
      },
    ],
  });
};

const resizeChart = () => {
  if (chartInstance) chartInstance.resize();
};

onMounted(() => {
  nextTick(initChart);
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  if (chartInstance) {
    chartInstance.dispose();
    chartInstance = null;
  }
});
</script>

<style lang="less" scoped>
.flow-panel {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  // background: linear-gradient(180deg, rgba(1, 50, 48, 0.78), rgba(1, 37, 39, 0.94));
  // box-shadow: inset 0 0 38px rgba(67, 255, 239, 0.12);
}

.flow-title {
   width: 100%;
      height: 66px;
      line-height: 20px;
      padding-left: 40px;
      background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xiaomai/xbt.png")
        no-repeat left bottom;
      font-size: 30px;
      text-align: left;
      color: rgba(254, 254, 254, 1);
}

.flow-chart {
  width: 100%;
  height: calc(100% - 54px);
}
</style>
